import { cn } from '@shared/lib';
import { TokenIcon } from '../TokenIcon';

interface RewardBadgeProps {
  /** Сколько жетонов получено. */
  amount: number;
  /** Подпись рядом с числом: «жетона получено». */
  caption: string;
  /** `sm` — в строке плашки «На сегодня» на главной (2026-10-23): монета и «+N», подпись — только для скринридера. */
  size?: 'md' | 'sm';
  className?: string;
}

/**
 * Полученная награда — крупное «+2» с монетой и мягким оранжевым свечением (владелец 2026-10-22: «+2 выдели как-нибудь
 * по-особому, серого текста поменьше»). Для выполненных «Задания дня» и «Миссии дня» вместо строки серого текста.
 */
export function RewardBadge({ amount, caption, size = 'md', className }: RewardBadgeProps) {
  if (size === 'sm') {
    return (
      <span
        title={`+${amount} ${caption}`}
        className={cn(
          'inline-flex items-center gap-1.5 rounded-[12px] bg-accent/[0.12] py-1 pl-1.5 pr-2.5 shadow-[0_0_20px_-8px_rgba(243,106,28,0.6)]',
          className,
        )}
      >
        <TokenIcon size={18} />
        <span className="font-serif text-[18px] font-semibold leading-none tabular-nums text-accent">+{amount}</span>
        <span className="sr-only">{caption}</span>
      </span>
    );
  }
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-[14px] bg-accent/[0.12] py-1.5 pl-2 pr-3 shadow-[0_0_28px_-8px_rgba(243,106,28,0.6)]',
        className,
      )}
    >
      <TokenIcon size={26} />
      <span className="font-serif text-[26px] font-semibold leading-none tabular-nums text-accent">+{amount}</span>
      <span className="text-[13px] font-medium leading-tight text-[#f7b48a]">{caption}</span>
    </span>
  );
}
